import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';
import * as _ from 'lodash';
import { CacheService } from './cache.service';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../environments/environment';
import { IndexDbService } from './index-db.service';
import { sortLanguageCodes } from '../_utils/utils';

@Injectable({
  providedIn: 'root',
})

export class VersionServiceService {
  
  env = environment;
  minVersion: string | null = null;
  featureFlags: any = {};
  currentVersion = environment.version;
  db: 'prod' | 'dev' | 'local' = environment.production ? 'prod' : 'dev';
  versionUpdateConfirm = null;
  isResyncing: boolean = false;
  unSubscribe = new Subject<void>();

  constructor(
    private fbs: FirebaseService,
    private idb: IndexDbService,
    private cc: CacheService
  ) {}

  check() {
    console.log('env', environment);
    this.fbs.getConfig().pipe(takeUntil(this.unSubscribe)).subscribe(async (config) => {
      console.log('config', config);
      this.cc.configSubject.next(config[0]);
      this.cc.config = config[0];
      this.cc.languageCodes.set(sortLanguageCodes(config[0].publishLanguageCodes));
      if (config.length) {
        this.minVersion = config[0].minVersion;
        console.log('Min Version', this.minVersion);
        console.log('Current Version', this.currentVersion);
        console.log('DB version', localStorage.getItem('version'));
        console.log('DB', localStorage.getItem('db'));
        // CHECK FOR VERSION UPGRADE
        if (
          this.currentVersion !== '##VERSION##' &&
          parseInt(this.currentVersion) < parseInt(this.minVersion)
        ) {
          window.location.reload();
        }
        if (
          this.currentVersion !== localStorage.getItem('version') ||
          this.db !== localStorage.getItem('db')
        ) {
          this.isResyncing = true;
          await this.idb.resync();
          localStorage.setItem('version', environment.version);
          localStorage.setItem('db', this.db);
          this.isResyncing = false;
        }
        await this.idb.initialise();
      }
    });
  }

  stopSubscription() {
    this.unSubscribe?.next();
    this.unSubscribe?.complete();
  }
}
